import contentstackLogo from "../../../assets/cms/contentstackLogo.svg"
import drupalLogo from "../../../assets/cms/drupalLogo.svg"
import kontentLogo from "../../../assets/cms/kontentLogo.svg"
import graphcmsLogo from "../../../assets/cms/graphcmsLogo.png"
import strapiLogo from "../../../assets/cms/strapiLogo.svg"
import flotiqLogo from "../../../assets/cms/flotiqLogo.svg"
import agilityLogo from "../../../assets/cms/agilityLogo.svg"
import wordpressLogo from "../../../assets/cms/wordpressLogo.png"
import buttercmsLogo from "../../../assets/cms/buttercmsLogo.svg"
import prismicLogo from "../../../assets/cms/prismicLogo.png"
import { CmsVendor } from "@modules/graphql/types"

export const CmsDataType = {
  ContentfulSpace: `space`,
  ContentfulOrganization: `organization`,
  DatoCmsProject: `project`,
  CosmicJsBucketSlug: `bucketSlug`,
  SanityProject: `project`,
  SanityDataset: `dataset`,
  ShopifyShop: `shop`,
}

export const cmsVendorFormattedName = {
  [CmsVendor.Contentful]: "Contentful",
  [CmsVendor.Sanity]: "Sanity",
}

export const manualIntegrations = [
  {
    name: `Agility CMS`,
    connected: false,
    logoUrl: agilityLogo,
    docUrl: `/docs/agility-cms/getting-started/`,
    details: null,
  },
  {
    name: `Contentstack`,
    connected: false,
    logoUrl: contentstackLogo,
    docUrl: `/docs/contentstack/getting-started/`,
    details: null,
  },
  {
    name: `Drupal`,
    connected: false,
    logoUrl: drupalLogo,
    docUrl: `/docs/drupal/getting-started/`,
    details: null,
  },
  {
    name: `Flotiq`,
    connected: false,
    logoUrl: flotiqLogo,
    docUrl: `/docs/flotiq/getting-started/`,
    details: null,
  },
  {
    name: `Graph CMS`,
    connected: false,
    logoUrl: graphcmsLogo,
    docUrl: `/docs/graph-cms/getting-started/`,
    details: null,
  },
  {
    name: `Kontent`,
    connected: false,
    logoUrl: kontentLogo,
    docUrl: `/docs/kontent/getting-started/`,
    details: null,
  },
  {
    name: `Strapi`,
    connected: false,
    logoUrl: strapiLogo,
    docUrl: `/docs/strapi/getting-started/`,
    details: null,
  },
  {
    name: `WordPress`,
    connected: false,
    logoUrl: wordpressLogo,
    docUrl: `/docs/wordpress/getting-started/`,
    details: null,
  },
  {
    name: `ButterCMS`,
    connected: false,
    logoUrl: buttercmsLogo,
    docUrl: `/docs/buttercms/getting-started/`,
    details: null,
  },
  {
    name: `Prismic CMS`,
    connected: false,
    logoUrl: prismicLogo,
    docUrl: `/cloud/docs/prismic-cms/getting-started/`,
    details: null,
  },
]

export function getCmsVendorIntegrationDocLink(vendor: CmsVendor) {
  switch (vendor) {
    case CmsVendor.Contentful:
      return "https://support.gatsbyjs.com/hc/en-us/articles/1500000965601-Connecting-to-Contentful-with-Quick-Connect"
    case CmsVendor.Sanity:
      return "https://support.gatsbyjs.com/hc/en-us/articles/360052324694-Connecting-to-Sanity-via-Quick-Connect"
    default:
      return "https://support.gatsbyjs.com/hc/en-us/sections/360011112314-Connecting-to-a-Content-Management-System"
  }
}

export function getGatsbyProvisionReadmeLink(vendor: CmsVendor) {
  switch (vendor) {
    case CmsVendor.Contentful:
      return "https://github.com/gatsbyjs/gatsby-provision-contentful#readme"
    case CmsVendor.Sanity:
      return "https://github.com/gatsbyjs/gatsby-provision-sanity#readme"
    default:
      return "" // TODO replace with link to generic docs on `gatsby-provision` when it exists
  }
}
